<template>
  <div class="content news-content pr-2">
    <div
      v-if="!show"
      class="spinner-loader"
    >
      <sync-loader />
      <p>Loading ...</p>
    </div>
    <div
      v-if="show"
      class="box"
    >
      <div class="content">
        <img
          v-if="news.headerimage"
          :src="news.headerimage"
        >
        <img
          v-if="!news.headerimage"
          src="/images/img_default.jpg"
        >
        <h3 class="title is-3">
          {{ news.title }}
        </h3>
        <div
          class="is-inline"
          v-html="news.text"
        />
        <div class="is-clearfix" />
      </div>
      <article
        v-if="user"
        class="media"
      >
        <div class="media-content">
          <p class="control">
            <textarea
              v-model="comment"
              class="textarea"
              placeholder="Add a comment..."
            />
          </p>
          <div
            class="control post-comment-btn"
            @click="addComment()"
          >
            <a class="button is-info">Post comment</a>
          </div>
        </div>
      </article>
      <!--Comments-->
      <div
        v-for="comment in news.comments"
        class="media wi"
      >
        <div class="media-left">
          <img
            v-if="comment.memberphoto"
            :src="comment.memberphoto"
          >
          <img
            v-if="!comment.memberphoto"
            src="/images/img_default.jpg"
          >
        </div>
        <div class="media-content">
          <div class="content">
            <p class="is-size-7-touch">
              <strong>{{ comment.name }}</strong>
              <small> · {{ comment.date }}</small>
              <br>
              {{ comment.text }}
              <br>
            </p>
          </div>
        </div>
        <div
          v-if="comment.canDelete"
          class="media-right"
          style="cursor:pointer;padding-right:20px;padding-top:10px"
        >
          <img
            src="/images/x-button.png"
            @click="delComment(comment.id)"
          >
        </div>
      </div>
      <div class="spacer" />
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'WholeNews',
    components: {
    },
    props: ['user', 'token'],
    data() {
      return {
        show: false,
        news: '',
        comment: ''
      }
    },
    computed: {
      formateDate() {
        let weekdays = [
          'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'
        ]
        let months = [
          'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ]
        let now = new Date()
        let day = now.getDate()
        let weekday = weekdays[now.getDay()]
        let month = months[now.getMonth()]
        let year = now.getFullYear()
        let hour = now.getHours()
        let dd = 'AM'
        let minutes = now.getMinutes()
        if (hour >= 12) {
          hour -= 12
          dd = 'PM'
        }
        if (hour === 0) hour = 12
        return `${weekday} ${month} ${day}, ${year} ${hour}.${minutes}${dd}`
      }
    },
    mounted() {
      this.getNews()
    },
    methods: {
      getNews() {
        this.$axios({
          method: 'POST',
          url: `general/getnewsitem/${this.$route.params.id}`,
          data: {
            token: this.token || ''
          }
        })
          .then((res) => {
            this.news = res.data[0]
            this.show = true
          })
          .catch((error) => {
            this.$emit('message', {error: true, showDialog: true, message: error.response.data.message})
          })
      },
      delComment(id) {
        this.$axios({
          method: 'POST',
          url: `ahlnews/delcomment/${id}`,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token,
            text: this.comment
          }
        }).then((res) => {
          this.$emit('message', {
            showDialog: true,
            error: res.data.error,
            message: res.data.message
          })
          if (!res.data.error) {
            var i = 0
            for (i = 0; i < this.news.comments.length; i++) {
              if (this.news.comments[i].id === id) {
                this.news.comments.splice(i, 1)
              }
            }
          }
        }).catch((error) => {
          this.$emit('message', {error: true,showDialog: true, message: error.response.data.message})
        })
      },
      addComment() {
        this.$axios({
          method: 'POST',
          url: `ahlnews/comment/${this.news.id}`,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token,
            text: this.comment
          }
        })
          .then((res) => {
            this.$emit('message', {
              showDialog: true,
              error: res.data.error,
              message: res.data.message
            })
            if (!res.data.error) {
              this.news.comments.unshift({
                ahlid: this.user.ahlid,
                memberphoto: this.user.memberphoto,
                name: `${this.user.first} ${this.user.middle} ${this.user.last}`,
                text: this.comment,
                date: this.formateDate
              })
              this.comment = ''
            }
          })
          .catch((error) => {
            this.$emit('message', {error: true,showDialog: true, message: error.response.data.message})
          })
      }
    }
  }
</script>
